module.exports = __webpack_public_path__ + "static/media/19_3.2a750707.png";